"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireWildcard(require("react"));

var _core = require("@material-ui/core");

var _DataTableStyles = _interopRequireDefault(require("./DataTableStyles"));

var _DataTableView = _interopRequireDefault(require("./DataTableView"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return; var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

var _default = function _default(_ref) {
  var fields = _ref.fields,
      search = _ref.search,
      _ref$defaultSort = _ref.defaultSort,
      defaultSort = _ref$defaultSort === void 0 ? function (order) {
    return function (a, b) {
      return a.createdAt > b.createdAt ? order === 'desc' ? -1 : 1 : order === 'asc' ? -1 : 1;
    };
  } : _ref$defaultSort,
      dataListParams = _ref.dataListParams;
  var classes = (0, _DataTableStyles["default"])();

  var _useState = (0, _react.useState)(null),
      _useState2 = _slicedToArray(_useState, 2),
      orderBy = _useState2[0],
      setOrderBy = _useState2[1];

  var _useState3 = (0, _react.useState)('desc'),
      _useState4 = _slicedToArray(_useState3, 2),
      order = _useState4[0],
      setOrder = _useState4[1];

  var _useState5 = (0, _react.useState)(0),
      _useState6 = _slicedToArray(_useState5, 2),
      forceMore = _useState6[0],
      setForceMore = _useState6[1];

  var _useState7 = (0, _react.useState)(false),
      _useState8 = _slicedToArray(_useState7, 2),
      loading = _useState8[0],
      setLoading = _useState8[1];

  var _useState9 = (0, _react.useState)(null),
      _useState10 = _slicedToArray(_useState9, 2),
      loaded = _useState10[0],
      setLoaded = _useState10[1];

  var CustomTableRow = function CustomTableRow(_ref2) {
    var object = _ref2.object,
        id = _ref2.id,
        _ref2$filter = _ref2.filter,
        filter = _ref2$filter === void 0 ? function (item) {
      return true;
    } : _ref2$filter;
    return /*#__PURE__*/_react["default"].createElement(_core.TableRow, null, Object.entries(fields).map(function (_ref3) {
      var _ref4 = _slicedToArray(_ref3, 2),
          label = _ref4[0],
          field = _ref4[1];

      return /*#__PURE__*/_react["default"].createElement(_core.TableCell, {
        key: label,
        className: !!field.nowrap ? classes.tableCellNoWrap : null
      }, field.value(object));
    }));
  };

  var handleHeaderCellClick = function handleHeaderCellClick(label) {
    return label === orderBy ? setOrder(order === 'desc' ? 'asc' : 'desc') : setOrderBy(label);
  };

  var selectedField = Object.entries(fields).find(function (_ref5) {
    var _ref6 = _slicedToArray(_ref5, 2),
        label = _ref6[0],
        field = _ref6[1];

    return label === orderBy;
  });
  var sortFunc = !!selectedField ? selectedField[1].sort(order) : defaultSort(order);

  var filterFunc = function filterFunc(item) {
    return !!Object.entries(fields).map(function (_ref7) {
      var _ref8 = _slicedToArray(_ref7, 2),
          label = _ref8[0],
          field = _ref8[1];

      return !!field.searchValue ? field.searchValue(item) : field.value(item);
    }).join(", ").includes(search || "");
  };

  return /*#__PURE__*/_react["default"].createElement(_DataTableView["default"], {
    classes: classes,
    orderBy: orderBy,
    order: order,
    fields: fields,
    onHeaderCellClick: handleHeaderCellClick,
    onLoadMoreClick: function onLoadMoreClick() {
      return setForceMore(function (forceMore) {
        return forceMore + 1;
      });
    },
    forceMore: forceMore,
    onLoaded: function onLoaded(loaded) {
      return setLoaded(loaded);
    },
    onLoading: function onLoading(loading) {
      return setLoading(loading);
    },
    loading: loading,
    loaded: loaded,
    dataListParams: _objectSpread({
      RenderComponent: CustomTableRow,
      clientSort: sortFunc,
      clientFilter: filterFunc
    }, dataListParams)
  });
};

exports["default"] = _default;